document.addEventListener('DOMContentLoaded', function () {
  const carousels = document.querySelectorAll('.largeslider-section');

  carousels.forEach(function (section) {
    const slider = section.querySelector('.custom-slider-section');

    if (!slider || slider.classList.contains('flickity-enabled')) return;

    imagesLoaded(slider, function () {
      const flickityNav = section.querySelector('.flickity-nav');
      const status = section.querySelector('.flickity-status');

      const ctaText = section.querySelector('.static-cta-text');
      const ctaLink = section.querySelector('.static-cta-link');
      const ctaText2 = section.querySelector('.static-cta-text-2');
      const ctaLink2 = section.querySelectorAll('.static-cta-link')[1];

      const prevBtn = section.querySelector('.flickity-prev');
      const nextBtn = section.querySelector('.flickity-next');

      const flkty = new Flickity(slider, {
        cellAlign: 'left',
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        draggable: false,
        groupCells: false
      });

      function updateSlideMeta() {
        const i = flkty.selectedIndex;
        const currentSlide = flkty.cells[i]?.element;
        if (!currentSlide) return;

        if (status) status.textContent = `${i + 1} / ${flkty.slides.length}`;

        if (ctaText) ctaText.textContent = currentSlide.dataset.cta || '';
        if (ctaLink) ctaLink.href = currentSlide.dataset.link || '#';
        if (ctaText && currentSlide.dataset.color) {
          ctaText.style.color = currentSlide.dataset.color;
        }

        if (ctaText2) ctaText2.textContent = currentSlide.dataset.cta2 || '';
        if (ctaLink2) ctaLink2.href = currentSlide.dataset.link2 || '#';
        if (ctaText2 && currentSlide.dataset.color2) {
          ctaText2.style.color = currentSlide.dataset.color2;
        }

        if (currentSlide.classList.contains('cropped')) {
          const image = currentSlide.querySelector('.main-image');
          if (image) {
            image.style.setProperty('--crop-position', currentSlide.dataset.cropPosition || 'center');
          }
        }
      }

      flkty.on('select', updateSlideMeta);
      updateSlideMeta();

      if (prevBtn) prevBtn.addEventListener('click', () => flkty.previous());
      if (nextBtn) nextBtn.addEventListener('click', () => flkty.next());

      section.querySelectorAll('.image-link').forEach(link => {
    link.addEventListener('click', e => {
  // If there's more than 1 slide, treat image clicks as navigation
  if (flkty.cells.length > 1) {
    e.preventDefault();
    flkty.next();
  }
  // Otherwise, let it be a real link
});
      });
    });
  });
});
